import { render, staticRenderFns } from "./contentFieldLegend.vue?vue&type=template&id=780e996c&"
import script from "./contentFieldLegend.vue?vue&type=script&lang=js&"
export * from "./contentFieldLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports